import * as R from "ramda";

const decorateValueToSave = ({ fieldId, field, value }) => {
  return {
    fieldId,
    value: {
      type: field.type,
      value: R.propOr(
        value,
        field.type
      )({
        text: value,
        countries: value && value.length ? value[0] : null,
        datetime: value
          ? {
              iso: value
            }
          : null,
        languages: {
          records: Array.isArray(value)
            ? value.map(optionId => ({
                id: optionId,
                value: null
              }))
            : []
        },
        file: {
          files: Array.isArray(value)
            ? value
            : R.prop("url")(value)
            ? [value]
            : []
        },
        dropdown: {
          records: Array.isArray(value)
            ? value.map(optionId => {
                return {
                  id: optionId,
                  value: R.compose(
                    R.propOr(null, "value"),
                    R.find(R.propEq("id", optionId)),
                    R.propOr([], "options")
                  )(field.settings)
                };
              })
            : []
        }
      })
    }
  };
};

export { decorateValueToSave };
